export const getMonthlyPrice = pricing => {
  const {
    price,
    monthlyPrice,
    monthsPerCycle
  } = pricing ?? {};
  return price != null ? Number(price) / (monthsPerCycle ?? 12) : Number(monthlyPrice) ?? 0;
};
export const getMonthsPerCycle = interval => {
  const unit = interval.unit ?? 'YEAR';
  const count = interval.count ?? 1;
  return unit === 'MONTH' ? count ?? 1 : unit === 'YEAR' ? count * 12 : 1;
};
//# sourceMappingURL=pricingCalculations.js.map